/**
 * External dependencies
 */
import React, { useState } from "react";
import { map } from "lodash";
import {
  Box,
  Heading,
  Divider,
} from "@towersystems/towersystems-design-system";
import classnames from "classnames";

/**
 * Internal dependencies
 */
import ReportFactory from "lib/report-factory";
import Button from "components/button";
import ButtonGroup from "components/button-group";

/**
 * Style dependencies
 */
import "./styles.scss";

const ReportListItem = ({ report, name, actions, disabled, ...props }) => {
  const [isPerformingAction, setIsPerformingAction] = useState(false);

  // make sure the buttons are disabled while an action is being performed
  const handleActionClick = (action) => async () => {
    setIsPerformingAction(true);
    try {
      await action();
    } catch (error) {}
    setIsPerformingAction(false);
  };

  const headerRender = () => {
    return (
      <Box>
        <Box
          padding="xlarge"
          display="flex"
          alignItems="center"
          justifyContent="spaceBetween"
        >
          <Heading level="4">{name}</Heading>
          <ButtonGroup>
            {map(actions, ({ onClick, label, ...a }) => (
              <Button
                key={a.key}
                {...a}
                onClick={handleActionClick(onClick)}
                disabled={isPerformingAction}
              >
                {label}
              </Button>
            ))}
          </ButtonGroup>
        </Box>
        <Divider />
      </Box>
    );
  };

  const component = React.useMemo(() => {
    return ReportFactory.create({
      report,
      reportId: report.id,
      template: report.template,
      renderHeader: () => null,
      includeEdits: true,
      showActions: false,
      draggable: false,
    });
  }, [report.id]);

  if (!report) {
    return null;
  }

  const classes = classnames("report__report-list-item", {
    "is-disabled": disabled,
  });

  return (
    <Box className={classes}>
      <Box className="report__report-list-item-inner">
        <Box display="flex" flexDirection="column" style={{ height: "100%" }}>
          {headerRender()}
          <Box style={{ height: "100%", position: "relative" }}>
            <Box
              style={{
                position: "absolute",
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
              }}
            >
              {component}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ReportListItem;
